import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { getValidationErrorMessage } from 'ScreenerApp/ts/features/screener/state/metric-filter-builder/metric-filter-builder.selectors';
import { ALL_CALC } from 'CalculationsApp/ts/constants/calc-search-types.constants';
import { EDIT_TALKING_POINTS_FEATURE, PDF_REPORT_BUILDER_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
import { BULLET_POINT_TOOLBAR_FORMATS, QuillToolbarFormatType, } from 'NewAngular/features/components/modals/text-edit/constants';
import { STOCK_SCREENER_IDENTIFIER } from 'ScreenerApp/ts/features/screener/constants';
import { EDIT } from 'SharingApp/ts/constants';
import { SAVE_TALKING_POINT_ERROR_MESSAGE, TALKING_POINTS_FOLDERABLE_APP_CONFIG, } from 'TalkingPointsApp/apps/talking-points-list-app/constants';
import { TALKING_POINT_TEMPLATE_TYPE_LABELS } from 'TalkingPointsApp/constants';
import { CustomPDFReportOrientation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-orientation.enum';
import { TalkingPointTemplateType } from 'TalkingPointsApp/enums/talking-point-template-type.enum';
import { CalculationsService } from 'CalculationsApp/ts/services/calculations.service';
import { CustomPDFReportModulePreviewImageService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report-module-preview-image.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { TalkingPointsService } from 'TalkingPointsApp/services/talking-points.service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import equal from 'NewAngular/utils/equal/deep-equal';
import { FIGURE, getBasicFormatted } from 'NewAngular/utils/number_formatter';
import { getBasicReversed } from 'NewAngular/utils/number_formatter_reverse';
import { parseValidationErrors } from 'TalkingPointsApp/utils';
import { fetchCalcRangeInfo, setCalcRangeInfoFetchSuccess, } from 'CalculationsApp/ts/state/range-data/range-data.actions';
import { setViewRootFolder } from 'FoldersApp/state/view-root-folder/view-root-folder.action';
import { validateRangePartialState, VALIDATION_STATUS, } from 'ScreenerApp/ts/features/screener/state/metric-filter-builder/metric-filter-builder.validators';
import { setTalkingPointToEdit } from 'TalkingPointsApp/apps/talking-points-list-app/state/talking-point-to-edit/talking-point-to-edit.action';
import * as i0 from "@angular/core";
import * as i1 from "TalkingPointsApp/services/talking-points.service";
import * as i2 from "@ngrx/store";
import * as i3 from "CustomPDFReportsApp/ts/services/custom-pdf-report-module-preview-image.service";
import * as i4 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i5 from "CalculationsApp/ts/services/calculations.service";
import * as i6 from "../../../../../../search/static/search/ts/features/autocomplete-in-place/metric-autocomplete-in-place/metric-autocomplete-in-place.component";
import * as i7 from "@angular/common";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i9 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i10 from "@angular/forms";
import * as i11 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i12 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i13 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i14 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i15 from "NewAngular/features/components/modals/text-edit/text-edit.component";
import * as i16 from "../../../../../../../ycharts/static/ts/features/pipes/index-of/index-of.pipe";
const _c0 = a0 => ({ "opacity": a0 });
const _c1 = a0 => ({ "is-checked": a0 });
const _c2 = a0 => ({ disabled: a0 });
const _c3 = () => ({ "height": "200px", "max-height": "200px" });
function TalkingPointsEditModalComponent_div_14_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵpipe(2, "indexOf");
    i0.ɵɵpipe(3, "indexOf");
    i0.ɵɵlistener("click", function TalkingPointsEditModalComponent_div_14_div_6_Template_div_click_1_listener() { const option_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.updateFieldState({ selectedTemplateType: option_r2.value })); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 17);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(5, "div", 18)(6, "div", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind2(2, 7, ctx_r2.validTemplateTypes, option_r2.value) === -1 || !ctx_r2.canEdit)("ngStyle", i0.ɵɵpureFunction1(13, _c0, i0.ɵɵpipeBind2(3, 10, ctx_r2.validTemplateTypes, option_r2.value) === -1 ? 0.5 : 1))("ngClass", i0.ɵɵpureFunction1(15, _c1, option_r2.value === ctx_r2.fieldState.selectedTemplateType));
    i0.ɵɵattribute("data-test-id", "template-type-" + i_r4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", option_r2.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", option_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", option_r2.description);
} }
function TalkingPointsEditModalComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtext(3, "Select Design");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(4, "div", 12);
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵtemplate(6, TalkingPointsEditModalComponent_div_14_div_6_Template, 7, 17, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r2.templateTypeOptions);
} }
function TalkingPointsEditModalComponent_div_15_div_13_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1, "Entry incomplete");
    i0.ɵɵelementEnd();
} }
function TalkingPointsEditModalComponent_div_15_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, TalkingPointsEditModalComponent_div_15_div_13_span_1_Template, 2, 0, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngSwitch", ctx_r2.validationStatus);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "INCOMPLETE");
} }
function TalkingPointsEditModalComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "label", 20);
    i0.ɵɵtext(2, "<> between:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21)(4, "div", 22)(5, "input", 23);
    i0.ɵɵtwoWayListener("ngModelChange", function TalkingPointsEditModalComponent_div_15_Template_input_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.formattedBounds.lower, $event) || (ctx_r2.formattedBounds.lower = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keypress", function TalkingPointsEditModalComponent_div_15_Template_input_keypress_5_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.inputKeypressHandler($event, ctx_r2.RANGE_INPUTS.LOWER_BOUND, ctx_r2.formattedBounds.lower)); })("blur", function TalkingPointsEditModalComponent_div_15_Template_input_blur_5_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.directInputChangeHandler(ctx_r2.RANGE_INPUTS.LOWER_BOUND, ctx_r2.formattedBounds.lower)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 24);
    i0.ɵɵelement(7, "div", 25);
    i0.ɵɵelementStart(8, "div", 26);
    i0.ɵɵelement(9, "div", 27)(10, "div", 28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 22)(12, "input", 29);
    i0.ɵɵtwoWayListener("ngModelChange", function TalkingPointsEditModalComponent_div_15_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.formattedBounds.upper, $event) || (ctx_r2.formattedBounds.upper = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keypress", function TalkingPointsEditModalComponent_div_15_Template_input_keypress_12_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.inputKeypressHandler($event, ctx_r2.RANGE_INPUTS.UPPER_BOUND, ctx_r2.formattedBounds.upper)); })("blur", function TalkingPointsEditModalComponent_div_15_Template_input_blur_12_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.directInputChangeHandler(ctx_r2.RANGE_INPUTS.UPPER_BOUND, ctx_r2.formattedBounds.upper)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(13, TalkingPointsEditModalComponent_div_15_div_13_Template, 2, 2, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2, !ctx_r2.sliderIsActive || ctx_r2.sliderCannotBeActive));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r2.sliderIsActive || ctx_r2.sliderCannotBeActive);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.formattedBounds.lower);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", !ctx_r2.sliderIsActive || ctx_r2.sliderCannotBeActive);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.formattedBounds.upper);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.sliderIsActive && !ctx_r2.sliderCannotBeActive);
} }
function TalkingPointsEditModalComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtext(3, "Text included with talking point");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "ycn-text-edit", 34);
    i0.ɵɵlistener("textChanged", function TalkingPointsEditModalComponent_div_16_Template_ycn_text_edit_textChanged_4_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateFieldState({ text: $event })); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r2.canEdit)("customScrollContainerStyles", i0.ɵɵpureFunction0(4, _c3))("extraFormats", ctx_r2.quillFormats)("text", ctx_r2.fieldState.text);
} }
function TalkingPointsEditModalComponent_ycn_simple_modal_footer_17_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-simple-modal-footer", 35);
    i0.ɵɵlistener("cancelHandler", function TalkingPointsEditModalComponent_ycn_simple_modal_footer_17_Template_ycn_simple_modal_footer_cancelHandler_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onCancel()); })("submitHandler", function TalkingPointsEditModalComponent_ycn_simple_modal_footer_17_Template_ycn_simple_modal_footer_submitHandler_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onSubmit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disableSubmission", !ctx_r2.isEdited || !ctx_r2.fieldState.selectedTemplateType || !ctx_r2.fieldState.talkingPointName || !ctx_r2.fieldState.selectedMetric || (!ctx_r2.fieldState.text || ctx_r2.fieldState.text === "<p><br></p>") || !ctx_r2.canEdit || ctx_r2.validationStatus !== ctx_r2.VALIDATION_STATUS_VALID)("errorText", ctx_r2.errorMessage)("modalTestId", "talking-points-edit-modal")("submitButtonText", "Save")("loading", ctx_r2.warningLoading);
} }
const noUiSlider = require('nouislider');
function isCollectionPostResponse(response) {
    return equal(Object.keys(response), ['talking_point', 'parent_folder_id']);
}
/**
 * Talking Points Edit Modal Component
 *
 * Handles editing existing talking points and creating new talking points.
 *
 * Output Properties:
 *  successHandler: emits when the request to save the talking point completes without an error.
 */
export class TalkingPointsEditModalComponent {
    constructor(talkingPointService, store, previewImageService, featureService, calculationsService, folderableAppConfig) {
        this.talkingPointService = talkingPointService;
        this.store = store;
        this.previewImageService = previewImageService;
        this.featureService = featureService;
        this.calculationsService = calculationsService;
        this.folderableAppConfig = folderableAppConfig;
        this.cancelHandler = new EventEmitter();
        this.successHandler = new EventEmitter();
        this.reportId = null;
        this.reportDefaultOnly = false;
        this.targetFolder = null;
        this.talkingPointToEdit = null;
        this.checkForPDFWarnings = false;
        this.fieldState = {
            talkingPointName: '',
            selectedMetric: null,
            selectedTemplateType: null,
            text: '',
        };
        this.initialFieldState = {
            talkingPointName: '',
            selectedMetric: null,
            selectedTemplateType: null,
            text: '',
        };
        this.isEdited = false;
        this.templateTypeOptions = [
            {
                value: TalkingPointTemplateType.LARGE_VALUE,
                label: TALKING_POINT_TEMPLATE_TYPE_LABELS[TalkingPointTemplateType.LARGE_VALUE],
                description: 'The most simple talking point design',
                icon: 'icon-tp-number-text-color',
            },
            {
                value: TalkingPointTemplateType.LARGE_VALUE_W_CHART,
                label: TALKING_POINT_TEMPLATE_TYPE_LABELS[TalkingPointTemplateType.LARGE_VALUE_W_CHART],
                description: 'Number with line chart and text',
                icon: 'icon-tp-number-chart-color',
            },
            {
                value: TalkingPointTemplateType.DONUT,
                label: TALKING_POINT_TEMPLATE_TYPE_LABELS[TalkingPointTemplateType.DONUT],
                description: 'Donut chart visualization with supplemental text',
                icon: 'icon-tp-donut-chart-color',
            },
            {
                value: TalkingPointTemplateType.RANGE_WITH_VALUES,
                label: TALKING_POINT_TEMPLATE_TYPE_LABELS[TalkingPointTemplateType.RANGE_WITH_VALUES],
                description: 'Range of values with text, designed for use with Risk Profiles',
                icon: 'icon-tp-range-color',
            },
        ];
        this.validTemplateTypes = Object.values(TalkingPointTemplateType);
        this.searchType = ALL_CALC;
        this.errorMessage = '';
        this.modalOpen = false;
        this.isTemplate = false;
        this.canEdit = true;
        this.hasEditFeature = false;
        this.isAlive = true;
        this.headerText = 'Create Talking Point';
        this.quillFormats = [QuillToolbarFormatType.SIZE, ...BULLET_POINT_TOOLBAR_FORMATS];
        this.sliderIsActive = false;
        this.sliderCannotBeActive = true;
        this.validationStatus = VALIDATION_STATUS.VALID;
        this.formattedBounds = { lower: null, upper: null };
        this.selectedLowerBound = null;
        this.selectedUpperBound = null;
        this.RANGE_INPUTS = {
            LOWER_BOUND: 'min',
            UPPER_BOUND: 'max',
        };
        this.RANGE_WITH_VALUES_TYPE = TalkingPointTemplateType.RANGE_WITH_VALUES;
        this.selectedRangeData = null;
        this.validationObject = null;
        this.VALIDATION_STATUS_VALID = VALIDATION_STATUS.VALID;
        this.refreshOnClose = false;
        this.fetchSubscription = null;
        this.mapStateToComponent = (state) => {
            this.canEdit = true;
            this.headerText = 'Create Talking Point';
            this.talkingPointToEdit = state;
            if (state && 'refreshOnClose' in state) {
                this.refreshOnClose = state.refreshOnClose;
            }
            if (this.talkingPointToEdit) {
                let newFieldState;
                if ('template_id' in this.talkingPointToEdit) {
                    this.isTemplate = true;
                    newFieldState = {
                        talkingPointName: this.talkingPointToEdit.name,
                        selectedMetric: this.talkingPointToEdit.state.metric.internal_name,
                        selectedTemplateType: this.talkingPointToEdit.state.template_type,
                        text: this.talkingPointToEdit.state.proposal_text,
                    };
                }
                else {
                    this.isTemplate = false;
                    this.canEdit =
                        this.hasEditFeature &&
                            (this.talkingPointToEdit.sharing.is_owner || this.talkingPointToEdit.sharing.permission === EDIT);
                    this.headerText = this.canEdit ? 'Edit Talking Point' : 'View Talking Point';
                    newFieldState = {
                        talkingPointName: this.talkingPointToEdit.name,
                        selectedMetric: this.talkingPointToEdit.metric.internal_name,
                        selectedTemplateType: this.talkingPointToEdit.template_type.value,
                        text: this.talkingPointToEdit.proposal_text,
                    };
                }
                if ('lower_bound' in this.talkingPointToEdit) {
                    this.selectedLowerBound = this.talkingPointToEdit.lower_bound;
                }
                if ('upper_bound' in this.talkingPointToEdit) {
                    this.selectedUpperBound = this.talkingPointToEdit.upper_bound;
                }
                this.initialFieldState = newFieldState;
                this.updateFieldState(newFieldState);
                this.updateValidTemplateTypes();
                this.openModal();
            }
        };
        this.saveHandlers = {
            next: (response) => {
                let talkingPoint;
                if (isCollectionPostResponse(response)) {
                    talkingPoint = response.talking_point;
                    // Only update the view root folder if talking points are guaranteed to be visible on the page.
                    if (this.folderableAppConfig &&
                        [TALKING_POINTS_FOLDERABLE_APP_CONFIG.appName].includes(this.folderableAppConfig.appName)) {
                        this.store.dispatch(setViewRootFolder({ id: response.parent_folder_id }));
                    }
                }
                else {
                    talkingPoint = response;
                }
                this.closeModal();
                this.successHandler.emit(talkingPoint);
            },
            error: (errorResponse) => {
                if (errorResponse.status === 400) {
                    this.errorMessage = parseValidationErrors(errorResponse?.error, SAVE_TALKING_POINT_ERROR_MESSAGE);
                }
                else if (errorResponse.status === 403) {
                    this.errorMessage = parseValidationErrors(errorResponse?.error, SAVE_TALKING_POINT_ERROR_MESSAGE);
                }
                else {
                    this.errorMessage = parseValidationErrors(errorResponse?.error, SAVE_TALKING_POINT_ERROR_MESSAGE);
                }
            },
        };
        this.store
            .select((state) => state.reducers.talkingPointToEdit)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe({ next: this.mapStateToComponent, error: () => { } });
        this.checkForPDFWarnings = this.featureService.userHasFeatures([PDF_REPORT_BUILDER_FEATURE]);
        this.hasEditFeature = this.featureService.userHasFeatures([EDIT_TALKING_POINTS_FEATURE]);
    }
    updateFieldState(update) {
        this.fieldState = { ...this.fieldState, ...update };
        this.isEdited = !equal(this.initialFieldState, this.fieldState);
        if ('selectedMetric' in update) {
            this.updateValidTemplateTypes();
        }
        const onRange = this.fieldState.selectedTemplateType === TalkingPointTemplateType.RANGE_WITH_VALUES;
        this.sliderCannotBeActive = !this.fieldState.selectedMetric;
        if (!onRange) {
            this.selectedLowerBound = null;
            this.selectedUpperBound = null;
            this.selectedRangeData = null;
            this.validationObject = null;
            this.validationStatus = VALIDATION_STATUS.VALID;
            this.errorMessage = '';
        }
        const shouldFetchMetricRangeData = this.fieldState.selectedMetric &&
            onRange &&
            ('selectedMetric' in update || 'selectedTemplateType' in update) &&
            !this.sliderCannotBeActive;
        if (shouldFetchMetricRangeData) {
            // If there is already a fetch pending, "cancel" it by unsubscribing.
            if (this.fetchSubscription !== null) {
                this.fetchSubscription.unsubscribe();
            }
            this.fetchMetricRangeData(this.fieldState.selectedMetric);
        }
    }
    openModal() {
        this.modalOpen = true;
    }
    onCancel() {
        this.cancelHandler.emit(this.refreshOnClose);
        this.closeModal();
    }
    closeModal() {
        this.modalOpen = false;
        this.resetModal();
    }
    updateValidTemplateTypes() {
        this.talkingPointService.getValidTemplateTypes(this.fieldState.selectedMetric).subscribe({
            next: (response) => {
                this.validTemplateTypes = response.valid_template_types;
                if (!this.validTemplateTypes.includes(this.fieldState.selectedTemplateType)) {
                    this.updateFieldState({ selectedTemplateType: null });
                }
            },
            error: (errorResponse) => {
                if (errorResponse.status === 404) {
                    this.errorMessage = 'Metric information not found. Please select a different metric.';
                }
                this.resetValidTemplateTypes();
            },
        });
    }
    resetValidTemplateTypes() {
        this.validTemplateTypes = Object.values(TalkingPointTemplateType);
    }
    resetModal() {
        if (this.previewImageSubscription) {
            this.previewImageSubscription.unsubscribe();
        }
        this.warningLoading = false;
        this.initialFieldState = {
            talkingPointName: '',
            selectedMetric: null,
            selectedTemplateType: null,
            text: '',
        };
        this.fieldState = {
            talkingPointName: '',
            selectedMetric: null,
            selectedTemplateType: null,
            text: '',
        };
        this.isEdited = false;
        this.resetValidTemplateTypes();
        this.errorMessage = '';
        this.sliderIsActive = false;
        this.selectedLowerBound = null;
        this.selectedUpperBound = null;
        this.selectedRangeData = null;
        this.validationObject = null;
        this.validationStatus = VALIDATION_STATUS.VALID;
        this.store.dispatch(setTalkingPointToEdit({ talkingPoint: null, refreshOnClose: false }));
    }
    submitModal(confirm = true) {
        if (!confirm)
            return;
        const params = {
            name: this.fieldState.talkingPointName,
            metric_name: this.fieldState.selectedMetric,
            proposal_text: this.fieldState.text,
            template_type: this.fieldState.selectedTemplateType,
            lower_bound: this.selectedLowerBound,
            upper_bound: this.selectedUpperBound,
        };
        if (this.talkingPointToEdit && !this.isTemplate) {
            this.talkingPointService
                .putTalkingPoint(this.talkingPointToEdit.id, params)
                .subscribe(this.saveHandlers);
        }
        else {
            if (this.targetFolder)
                params.targetFolder = this.targetFolder;
            this.talkingPointService.postTalkingPoint(params).subscribe(this.saveHandlers);
        }
    }
    onSubmit() {
        // All fields must be filled out to submit the modal
        if (!this.fieldState.selectedTemplateType ||
            !this.fieldState.talkingPointName ||
            !this.fieldState.selectedMetric ||
            !this.fieldState.text ||
            this.fieldState.text === '<p><br></p>' ||
            !this.canEdit ||
            this.validationStatus !== VALIDATION_STATUS.VALID) {
            return;
        }
        this.warningLoading = true;
        const params = this.talkingPointToEdit && !this.isTemplate
            ? {
                talking_point_id: this.talkingPointToEdit.id,
                proposal_text: this.fieldState.text,
            }
            : {
                name: 'Temporary talking point',
                metric: { internal_name: this.fieldState.selectedMetric },
                proposal_text: this.fieldState.text,
                template_type: { value: this.fieldState.selectedTemplateType },
                lower_bound: this.selectedLowerBound,
                upper_bound: this.selectedUpperBound,
            };
        if (!this.checkForPDFWarnings) {
            this.submitModal();
            return;
        }
        // get PDF report related warnings
        this.previewImageSubscription = this.previewImageService
            .getPDFReportModuleProposalsWarningMessage(params, this.reportOrientation, this.reportId)
            .subscribe({
            next: (response) => {
                this.warningLoading = false;
                if (response.warning) {
                    this.warningModal.openModal();
                }
                else {
                    this.submitModal();
                }
            },
            error: () => {
                // If the request to get the warning message fails, submit the modal anyway
                // so that we don't block the user from saving the talking point
                this.warningLoading = false;
                this.submitModal();
            },
        });
    }
    fetchMetricRangeData(calcName) {
        this.store.dispatch(fetchCalcRangeInfo());
        this.setSliderInactive();
        this.fetchSubscription = this.calculationsService
            .getMetricRangeInfo(STOCK_SCREENER_IDENTIFIER, calcName)
            .subscribe({
            next: (data) => {
                // if we get an empty response, set slider to inactive.
                this.store.dispatch(setCalcRangeInfoFetchSuccess({ data }));
                // short circuit if the range type is no longer selected by the time this request resolved.
                if (this.fieldState.selectedTemplateType !== TalkingPointTemplateType.RANGE_WITH_VALUES)
                    return;
                // initial values on slider are either the existing values (when editing)
                // or the min/max of the `value_range` of the metric.
                let { selectedLowerBound, selectedUpperBound } = this;
                let metricRangeData = {
                    abbrev_label: '',
                    feature_needed: 'metric',
                    label: '',
                    slider_steps: ['-100', '-50', '0', '50', '100'],
                    type: 'figure',
                    value_range: [-100, 100],
                };
                if (!Object.keys(data).length) {
                    if (selectedLowerBound === null || selectedLowerBound === undefined) {
                        selectedLowerBound = -100;
                    }
                    if (selectedUpperBound === null || selectedUpperBound === undefined) {
                        selectedUpperBound = 100;
                    }
                }
                else {
                    metricRangeData = data[this.fieldState.selectedMetric];
                    if (selectedLowerBound === null || selectedLowerBound === undefined) {
                        [selectedLowerBound] = metricRangeData.value_range || [-100];
                    }
                    if (selectedUpperBound === null || selectedUpperBound === undefined) {
                        [, selectedUpperBound] = metricRangeData.value_range || [-100, 100];
                    }
                }
                this.formattedBounds.lower = getBasicFormatted(selectedLowerBound, metricRangeData.type);
                this.formattedBounds.upper = getBasicFormatted(selectedUpperBound, metricRangeData.type);
                this.selectedLowerBound = selectedLowerBound;
                this.selectedUpperBound = selectedUpperBound;
                this.selectedRangeData = metricRangeData;
                this.validateRange();
                this.initializeSlider(metricRangeData, selectedLowerBound, selectedUpperBound);
            },
            error: () => {
                this.setSliderInactive();
            },
        });
    }
    // Initializes slider when "Range with Values" is selected
    initializeSlider(data, startMin, startMax) {
        const slider = document.getElementById('range-slider');
        // reset the slider if it has already been initialized.
        if (slider.noUiSlider !== undefined) {
            slider.noUiSlider.destroy();
        }
        // set slider to `inactive` if we don't have data.
        if (!data.slider_steps || Object.keys(data.slider_steps).length === 0) {
            this.setSliderInactive();
            return;
        }
        const sliderRange = this.getFormattedSliderRange([...data.slider_steps]);
        noUiSlider.create(slider, {
            start: [startMin, startMax],
            range: sliderRange,
            connect: [false, true, false],
        });
        slider.noUiSlider.on('change', () => {
            const [min, max] = slider.noUiSlider.get().map((value) => Number(value));
            this.formattedBounds.lower = getBasicFormatted(min, data.type);
            this.formattedBounds.upper = getBasicFormatted(max, data.type);
            if (min !== this.selectedLowerBound || max !== this.selectedUpperBound) {
                this.isEdited = true;
            }
            this.selectedLowerBound = min;
            this.selectedUpperBound = max;
            this.validateRange();
            // this.store.dispatch(setRightMetricFilterTokens({ metricFilterTokens: [min, max] }));
        });
        this.sliderIsActive = true;
    }
    getFormattedSliderRange(sliderSteps) {
        /* Formats `data.slider_steps` into an object with `N%` keys to allow nonlinear step values.
         *           Also adds `min` and `max` keys, which are required for the `range` option.
         * i.e. {
         *      min: ...,
         *      2%: ..,
         *      4%: ..,
         *      ...
         *      98%: ...,
         *      max: ...
         *   }
         */
        const sliderRange = {};
        const maxRange = sliderSteps.pop();
        const multiplier = 100 / sliderSteps.length;
        sliderSteps.forEach((step, index) => {
            const percentageFormatted = `${Math.ceil(index * multiplier)}%`;
            sliderRange[percentageFormatted] = Number(step);
        });
        // add `max` to range.
        sliderRange.max = Number(maxRange);
        // rename 0% as `min`
        sliderRange.min = sliderRange['0%'];
        delete sliderRange['0%'];
        return sliderRange;
    }
    setSliderInactive() {
        this.sliderIsActive = false;
        // this.store.dispatch(setRightMetricFilterTokens({ metricFilterTokens: [] }));
    }
    // Handles keypress for direct input changes
    inputKeypressHandler(event, inputType, selectedValue) {
        if (event.key === 'Enter') {
            this.directInputChangeHandler(inputType, selectedValue);
        }
    }
    // Handles direct input changes
    directInputChangeHandler(inputType, selectedValue) {
        if (!selectedValue) {
            return;
        }
        // If `selectedRangeData` is undefined because the modal was closed
        // then do not proceed.
        if (!this.selectedRangeData) {
            return;
        }
        const metricType = this.selectedRangeData.type || FIGURE;
        switch (inputType) {
            case this.RANGE_INPUTS.LOWER_BOUND:
                const lowerBound = getBasicReversed(selectedValue, metricType);
                // if the `selectedValue` is valid, set it to the existing value.
                if (lowerBound !== false) {
                    this.selectedLowerBound = lowerBound;
                    this.isEdited = true;
                }
                break;
            case this.RANGE_INPUTS.UPPER_BOUND:
                const upperBound = getBasicReversed(selectedValue, metricType);
                // if the `selectedValue` is valid, set it to the existing value.
                if (upperBound !== false) {
                    this.selectedUpperBound = upperBound;
                    this.isEdited = true;
                }
                break;
            // no default
        }
        // update slider positions & values.
        const slider = document.getElementById('range-slider');
        // @ts-ignore
        slider.noUiSlider.set([this.selectedLowerBound, this.selectedUpperBound]);
        this.validateRange();
        this.formattedBounds.lower = getBasicFormatted(this.selectedLowerBound, metricType);
        this.formattedBounds.upper = getBasicFormatted(this.selectedUpperBound, metricType);
        //
        // this.store.dispatch(
        //     setRightMetricFilterTokens({
        //         metricFilterTokens: [this.selectedLowerBound as number, this.selectedUpperBound as number],
        //     })
        // );
    }
    validateRange() {
        if (this.selectedLowerBound !== null && this.selectedUpperBound !== null) {
            this.validationObject = validateRangePartialState([
                this.selectedLowerBound.toString(),
                this.selectedUpperBound.toString(),
            ]);
        }
        else {
            this.validationObject = {
                index: null,
                status: VALIDATION_STATUS.INCOMPLETE,
                reason: null,
            };
        }
        this.errorMessage = getValidationErrorMessage(this.validationObject);
        this.validationStatus = this.validationObject.status;
    }
}
TalkingPointsEditModalComponent.ɵfac = function TalkingPointsEditModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointsEditModalComponent)(i0.ɵɵdirectiveInject(i1.TalkingPointsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.CustomPDFReportModulePreviewImageService), i0.ɵɵdirectiveInject(i4.FeatureService), i0.ɵɵdirectiveInject(i5.CalculationsService), i0.ɵɵdirectiveInject(FOLDERABLE_APP_CONFIG, 8)); };
TalkingPointsEditModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TalkingPointsEditModalComponent, selectors: [["ycn-talking-points-edit-modal"]], viewQuery: function TalkingPointsEditModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.warningModal = _t.first);
    } }, inputs: { reportId: "reportId", reportDefaultOnly: "reportDefaultOnly", reportOrientation: "reportOrientation", targetFolder: "targetFolder" }, outputs: { cancelHandler: "cancelHandler", successHandler: "successHandler" }, standalone: false, decls: 19, vars: 19, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "mb-3"], [1, "mb-1"], [1, "form-label", "form-label-thin", "d-block"], ["type", "text", "placeholder", "Ex: Max Drawdown", "data-test-id", "talking-point-name-input", "ycnDisabled", "", 1, "form-control", 3, "keydown.enter", "ngModelChange", "disabled", "ngModel"], ["data-test-id", "talking-point-metric-input", 3, "submitHandler", "submitModalHandler", "appendToBody", "inputDisabled", "displayIdentifier", "hideCancelButton", "placeholder", "searchType", "defaultOnly"], ["class", "mb-3", 4, "ngIf"], [3, "disableSubmission", "errorText", "modalTestId", "submitButtonText", "loading", "cancelHandler", "submitHandler", 4, "ngIf"], [3, "confirmHandler", "confirmButtonText", "cancelButtonText", "confirmHeader", "confirmText"], [1, "divider-horizontal"], [1, "row", "gutters-17", "justify-content-around", "pt-12", "pb-12"], ["class", "col-auto", 4, "ngFor", "ngForOf"], [1, "col-auto"], ["ycnDisabled", "", 1, "template-module-report", 3, "click", "disabled", "ngStyle", "ngClass"], ["ycnIcon", "", 3, "name"], [1, "template-module-title", 3, "textContent"], [1, "template-module-subtitle", 3, "textContent"], [1, "form-label", "form-label-large"], [1, "row", 3, "ngClass"], [1, "col-2"], ["type", "text", "data-test-id", "Lower Bound Input", "ycnDisabled", "", 1, "form-control", 3, "ngModelChange", "keypress", "blur", "disabled", "ngModel"], [1, "col"], ["id", "range-slider", 1, "sliders", "noUi-target", "noUi-ltr", "noUi-horizontal", "slider-active"], [1, "sliders", "noUi-target", "noUi-horizontal", "slider-disabled"], [1, "noUi-handle", "noUi-handle-lower", "noUi-handle-disabled"], [1, "noUi-handle", "noUi-handle-upper", "noUi-handle-disabled"], ["type", "text", "ycnDisabled", "", "data-test-id", "Upper Bound Input", 1, "form-control", 3, "ngModelChange", "keypress", "blur", "disabled", "ngModel"], ["class", "feedback", 3, "ngSwitch", 4, "ngIf"], [1, "feedback", 3, "ngSwitch"], ["class", "feedback-neutral", 4, "ngSwitchCase"], [1, "feedback-neutral"], ["ycnDisabled", "", 3, "textChanged", "disabled", "customScrollContainerStyles", "extraFormats", "text"], [3, "cancelHandler", "submitHandler", "disableSubmission", "errorText", "modalTestId", "submitButtonText", "loading"]], template: function TalkingPointsEditModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function TalkingPointsEditModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.onCancel(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function TalkingPointsEditModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.onCancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6);
        i0.ɵɵtext(7, "Talking Point Name");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "input", 7);
        i0.ɵɵlistener("keydown.enter", function TalkingPointsEditModalComponent_Template_input_keydown_enter_8_listener() { return ctx.onSubmit(); })("ngModelChange", function TalkingPointsEditModalComponent_Template_input_ngModelChange_8_listener($event) { return ctx.updateFieldState({ talkingPointName: $event }); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 4)(10, "div", 5)(11, "div", 6);
        i0.ɵɵtext(12, "Talking Point Metric");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-metric-autocomplete-in-place", 8);
        i0.ɵɵlistener("submitHandler", function TalkingPointsEditModalComponent_Template_ycn_metric_autocomplete_in_place_submitHandler_13_listener($event) { return ctx.updateFieldState({ selectedMetric: $event.search_id }); })("submitModalHandler", function TalkingPointsEditModalComponent_Template_ycn_metric_autocomplete_in_place_submitModalHandler_13_listener($event) { return ctx.updateFieldState({ selectedMetric: $event.internal_name }); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(14, TalkingPointsEditModalComponent_div_14_Template, 8, 1, "div", 9)(15, TalkingPointsEditModalComponent_div_15_Template, 14, 8, "div", 9)(16, TalkingPointsEditModalComponent_div_16_Template, 6, 5, "div", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(17, TalkingPointsEditModalComponent_ycn_simple_modal_footer_17_Template, 1, 5, "ycn-simple-modal-footer", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "ycn-confirm-modal", 11);
        i0.ɵɵlistener("confirmHandler", function TalkingPointsEditModalComponent_Template_ycn_confirm_modal_confirmHandler_18_listener($event) { return ctx.submitModal($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.headerText);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", !ctx.canEdit)("ngModel", ctx.fieldState.talkingPointName);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("appendToBody", false)("inputDisabled", !ctx.canEdit)("displayIdentifier", ctx.fieldState.selectedMetric)("hideCancelButton", true)("placeholder", "Enter metric")("searchType", ctx.searchType)("defaultOnly", ctx.reportDefaultOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.fieldState.talkingPointName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.fieldState.selectedTemplateType === ctx.RANGE_WITH_VALUES_TYPE);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.fieldState.selectedTemplateType);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.fieldState.selectedTemplateType);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmButtonText", "Continue")("cancelButtonText", "Cancel")("confirmHeader", "Alert")("confirmText", "The text entered is too long for a Talking Points Module, and will overflow into the module below. Continue or update with a shortened version of the text.");
    } }, dependencies: [i6.MetricAutocompleteInPlaceComponent, i7.NgClass, i7.NgForOf, i7.NgIf, i7.NgStyle, i7.NgSwitch, i7.NgSwitchCase, i8.ConfirmModalComponent, i9.DisabledDirective, i10.DefaultValueAccessor, i10.NgControlStatus, i10.NgModel, i11.IconDirective, i12.ModalBaseComponent, i13.SimpleModalFooterComponent, i14.SimpleModalHeaderComponent, i15.TextEditComponent, i16.IndexOfPipe], encapsulation: 2 });
